import * as watchers from './error-handling-watchers'
import { fork } from 'redux-saga/effects'

export default [
  fork(watchers.apiErrorsWatcher),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/errors/index.js
 **/